module.exports = __webpack_public_path__ + "static/media/IMG_20201031_0004.78588829.jpg";